export default __webpack_public_path__ + "static/media/platinum.4a7ae238.png";